export default __webpack_public_path__ + "static/media/allison.79a5189d.bin";